import { Inject, Injectable, Optional } from '@angular/core';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MatMomentDateAdapterOptions,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Moment } from 'moment';
import moment from 'moment-timezone';

@Injectable()
export class DateOnlyAdapter extends MomentDateAdapter {


    constructor(
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
        @Optional() @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS) _options?: MatMomentDateAdapterOptions,
    ) {
        super(dateLocale, _options);
    }


    override format(date: Moment, displayFormat: string): string {
        if (!date) return '';

        return moment({ year: date.year(), month: date.month(), day: date.date() }).format(displayFormat);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override parse(value: any, parseFormat: moment.MomentFormatSpecification): moment.Moment | null {
        if (!value) {
            return null;
        }
        let m: moment.Moment;
        if (typeof value === 'string') {
            m = moment(value, parseFormat, true);
        } else if (moment.isMoment(value)) {
            m = value.clone();
        } else if (value instanceof Date) {
            m = moment(value);
        } else {
            return null;
        }

        return m.isValid() ? this.createDate(m.year(), m.month(), m.date()) : null;
    }


    override compareDate(first: Moment, second: Moment): number {
        return (first.year() - second.year()) + (first.month() - second.month()) + (first.date() - second.date());
    }

    override getFirstDayOfWeek(): number {
        return 0;
    }
}
